import React, { useMemo } from "react";
import { ResponsivePie } from "@nivo/pie";
import { Box, Typography, useTheme } from "@mui/material";
import { useGetSalesQuery } from "../state/api";

const BreakdownChart: React.FC<IBreakdownChartProps> = ({ isDashboard = false }) => {
    const theme = useTheme();
    const { data, isLoading } = useGetSalesQuery(1);
    const formattedData = useMemo(() => {
        if (data != undefined) {
            const formattedData = Object.entries(data?.salesByCategory).map(
                ([category, sales], i) => ({
                    id: category,
                    label: category,
                    value: sales
                })
            );
            return formattedData;
        }
        return []
    }, [data])
    return (
        data ?
            <Box
                height={isDashboard ? "400px" : "100%"}
                width={undefined}
                minHeight={isDashboard ? "325px" : undefined}
                minWidth={isDashboard ? "325px" : undefined}
                position="relative"
            >
                <ResponsivePie
                    data={formattedData}
                    theme={{
                        axis: {
                            domain: {
                                line: {
                                    stroke: theme.palette.secondary.main,
                                },
                            },
                            legend: {
                                text: {
                                    fill: theme.palette.secondary.main,
                                },
                            },
                            ticks: {
                                line: {
                                    stroke: theme.palette.secondary.main,
                                    strokeWidth: 1,
                                },
                                text: {
                                    fill: theme.palette.secondary.main,
                                },
                            },
                        },
                        legends: {
                            text: {
                                fill: theme.palette.secondary.main,
                            },
                        },
                        tooltip: {
                            container: {
                                color: theme.palette.primary.main,
                            },
                        },
                    }}
                    colors={{ scheme: "dark2" }}
                    margin={
                        isDashboard
                            ? { top: 40, right: 80, bottom: 100, left: 50 }
                            : { top: 40, right: 80, bottom: 80, left: 80 }
                    }
                    sortByValue={true}
                    innerRadius={0.45}
                    activeOuterRadiusOffset={8}
                    borderWidth={1}
                    borderColor={{
                        from: "color",
                        modifiers: [["darker", 0.2]],
                    }}
                    enableArcLinkLabels={!isDashboard}
                    arcLinkLabelsTextColor={theme.palette.secondary.main}
                    arcLinkLabelsThickness={2}
                    arcLinkLabelsColor={{ from: "color" }}
                    arcLabelsSkipAngle={10}
                    arcLabelsTextColor={{
                        from: "color",
                        modifiers: [["darker", 2]],
                    }}
                    legends={[
                        {
                            anchor: "bottom",
                            direction: "row",
                            justify: false,
                            translateX: isDashboard ? 20 : 0,
                            translateY: isDashboard ? 50 : 56,
                            itemsSpacing: 0,
                            itemWidth: 85,
                            itemHeight: 18,
                            itemTextColor: theme.palette.secondary.light,
                            itemDirection: "left-to-right",
                            itemOpacity: 1,
                            symbolSize: 18,
                            symbolShape: "circle",
                            effects: [
                                {
                                    on: "hover",
                                    style: {
                                        itemOpacity: 1,
                                        itemTextColor: theme.palette.secondary.main,
                                    },
                                },
                            ],
                        },
                    ]}
                />
                <Box
                    position={'absolute'}
                    top={'50%'}
                    left={'50%'}
                    color={theme.palette.secondary.dark}
                    textAlign={'center'}
                    sx={{
                        pointerEvents: 'none',
                        transform: isDashboard
                            ? "translate(-75%, -170%)"
                            : "translate(-50%, -100%)",
                    }}>
                    <Typography variant="h6">
                        {!isDashboard && "Total:"} ${data.yearlySalesTotal}
                    </Typography>
                </Box>
            </Box>
            : <>Loading...</>
    );
};

export default BreakdownChart;
interface IBreakdownChartProps {
    isDashboard?: boolean;
}